import React from 'react';
import PropTypes from 'prop-types';
import styles from './PageToolbar.module.scss';

/* ────────────────────────────────────────────────────────────
 * PageToolbar — secondary horizontal bar between PageHeader
 * and PagePanel. Holds tab strips, "entries per page" pickers,
 * search inputs — anything that's a page-level filter or
 * mode-switch but doesn't fit cleanly inside PageHeader.
 *
 *   <PageToolbar
 *     left={<TabRow>...</TabRow>}
 *     right={<><span>Entries per page</span><Select>...</Select></>}
 *   />
 *
 * Both slots are optional. If only one is given, it occupies
 * the full row; the empty side just collapses.
 * ──────────────────────────────────────────────────────────── */

const PageToolbar = ({ left, right, className }) => {
  const toolbarClass = [styles.toolbar, className || ''].filter(Boolean).join(' ');

  return (
    <div className={toolbarClass}>
      {left && <div className={styles.left}>{left}</div>}
      {right && <div className={styles.right}>{right}</div>}
    </div>
  );
};

PageToolbar.propTypes = {
  left: PropTypes.node,
  right: PropTypes.node,
  className: PropTypes.string,
};

PageToolbar.defaultProps = {
  left: null,
  right: null,
  className: '',
};

export default PageToolbar;
